var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaUnternehmen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#eff2fa;}.cls-3{fill:#fff;}.cls-4{fill:#b2b9bf;}.cls-5{fill:#7c828d;}.cls-6{fill:#ffd24f;}.cls-7{fill:#fc9b28;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.23,35.87V59.1H17s0-23.23,23.22-23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.75,35.87V59.1H49.52s0-23.23,23.23-23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.72,87v65H128.49V124.13H96V152H72.75V87Zm-11.61,25.55v-9.29a4.65,4.65,0,0,0-9.3,0v9.29Zm-23.23,0v-9.29a4.65,4.65,0,1,0-9.29,0v9.29Zm-23.23,0v-9.29a4.65,4.65,0,1,0-9.29,0v9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.75,87v65h-65V59.1h65ZM56.49,138.06v-9.29a4.65,4.65,0,0,0-9.29,0v9.29Zm0-25.54v-9.29a4.65,4.65,0,1,0-9.29,0v9.29Zm0-25.55V77.68a4.65,4.65,0,1,0-9.29,0V87ZM33.27,138.06v-9.29a4.65,4.65,0,0,0-9.29,0v9.29Zm0-25.54v-9.29a4.65,4.65,0,1,0-9.29,0v9.29Zm0-25.55V77.68a4.65,4.65,0,1,0-9.29,0V87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144.31,75.35,144.75,87H130.81l.45-11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.94,66.06l.37,9.29H131.26l.37-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143.59,56.77l.35,9.29H131.63l.35-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.24,47.48l.35,9.29H132l.34-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M142.43,26.58l.81,20.9H132.32l.82-20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.11,103.23v9.29h-9.3v-9.29a4.65,4.65,0,0,1,9.3,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 95.98,
    y: 124.13,
    width: 32.52,
    height: 27.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.13,75.35,121.52,87H107.59L108,75.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.83,66.06l.3,9.29H108l.31-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M120.53,56.77l.3,9.29H108.29l.3-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.2,47.48l.33,9.29H108.59l.32-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.2,17.29l1,30.19H108.91l1-30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.88,103.23v9.29h-9.29v-9.29a4.65,4.65,0,1,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98,75.35,98.3,87H84.36l.35-11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.7,66.06,98,75.35H84.71L85,66.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.42,56.77l.28,9.29H85l.28-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M97.14,47.48l.28,9.29H85.25l.27-9.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M96,8l1.16,39.48H85.52L86.69,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M93.65,103.23v9.29H84.36v-9.29a4.65,4.65,0,1,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.75,26.58v9.29c-23.23,0-23.23,23.23-23.23,23.23H40.23s0-32.52,32.52-32.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.49,128.77v9.29H47.2v-9.29a4.65,4.65,0,0,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.49,103.23v9.29H47.2v-9.29a4.65,4.65,0,1,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M56.49,77.68V87H47.2V77.68a4.65,4.65,0,1,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.23,26.58v9.29C17,35.87,17,59.1,17,59.1H7.72s0-32.52,32.51-32.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.27,128.77v9.29H24v-9.29a4.65,4.65,0,0,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.27,103.23v9.29H24v-9.29a4.65,4.65,0,1,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.27,77.68V87H24V77.68a4.65,4.65,0,1,1,9.29,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.33,59.1H14.69c0-.26.29-25.55,25.54-25.55v4.64c-20.67,0-20.9,20.05-20.9,20.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.85,59.1H47.2c0-.26.29-25.55,25.55-25.55v4.64c-20.67,0-20.9,20.05-20.9,20.91Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaUnternehmen);
export default __webpack_public_path__ + "static/media/ka_unternehmen.2ab4c3352880d30c0b91dd99918e9017.svg";
export { ForwardRef as ReactComponent };